import { EnvironmentProvider, LanguageProvider, TranslationsContextWrapper } from '@telia-common-components/shared';
import React from 'react';
import AddressAutocompleteContent from './AddressAutocompleteContent';
import AddressAutocompleteStore from './AddressAutocompleteStore';
let addressAutocompleteStore;
const AddressAutocomplete = (props) => {
    const { tier, app, language, labelsPrefix, roomLabel, onSubmit, address, room, autoSubmit, disableTranslationsStatistics, isTestEnvironment, isLoading } = props;
    const fixedLabelPrefix = labelsPrefix ? `${labelsPrefix}.` : '';
    if (!addressAutocompleteStore) {
        addressAutocompleteStore = new AddressAutocompleteStore(tier, app, language, address, room, onSubmit);
    }
    React.useEffect(() => {
        var _a;
        if (!addressAutocompleteStore.isIniting &&
            ((address === null || address === void 0 ? void 0 : address.id) !== ((_a = addressAutocompleteStore.selectedAddress) === null || _a === void 0 ? void 0 : _a.id) || (!!roomLabel && roomLabel !== addressAutocompleteStore.roomTextInMemory))) {
            addressAutocompleteStore = new AddressAutocompleteStore(tier, app, language, address, room, onSubmit);
        }
    }, [address, room, roomLabel]);
    React.useEffect(() => () => {
        addressAutocompleteStore = null;
    }, []);
    return (React.createElement(EnvironmentProvider, { app: app, tier: tier },
        React.createElement(LanguageProvider, { lang: language },
            React.createElement(TranslationsContextWrapper, { disableStatistics: disableTranslationsStatistics, isTestEnvironment: isTestEnvironment },
                React.createElement(AddressAutocompleteContent, { onSubmit: onSubmit, labelsPrefix: fixedLabelPrefix, addressAutocompleteStore: addressAutocompleteStore, roomLabel: roomLabel, autoSubmit: autoSubmit, isLoading: isLoading })))));
};
export { AddressAutocomplete };
